import React, { useEffect, useState, memo } from 'react';
export const UrgencyBar = memo(function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full" data-id="element-184">
      <a href="#compra" className="block w-full bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white py-2 px-4 text-center shadow-md hover:opacity-90 transition-opacity cursor-pointer" data-id="element-185">
        <p className="text-[11px] md:text-[13px] font-black uppercase tracking-wide flex items-center justify-center gap-2 flex-wrap" data-id="element-186">
          <span className="text-[9px]" data-id="element-187">
            🔥 <span className="text-yellow-300" data-id="element-188">Megapack Domina Tu Mente</span>{' '}
            — Precio especial termina en:
          </span>
          <span className="bg-black/30 px-2 py-0.5 rounded font-black text-yellow-300 tracking-widest text-[9px]" data-id="element-189">
            ⏳ {timeString}
          </span>
          <span className="hidden md:inline" data-id="element-190">|</span>
          <span className="text-white/90 text-[9px]" data-id="element-191">
            👉 Hacé clic y asegurá tu precio ahora
          </span>
        </p>
      </a>
    </div>;
});